import React, { useRef, useState } from "react";
import styles from "./TemplatesList.module.scss";
import Icon from "engage/components/Icon/Icon";
import cx from "classnames";
import { formatSecondsToDuration } from "engage/utils/TimeUtil";
import { useTranslation } from "react-i18next";
import Highlighter from "react-highlight-words";
import DotsBtn from "engage/components/Menu/DotsBtn";
import Menu from "engage/components/Menu/Menu";
import MenuItem from "engage/components/Menu/MenuItem";
import Tooltip from "engage/components/Tooltip/Tooltip";
import useFixedCardMenu from "engage/features/Editor/hooks/useFixedCardMenu";

export const TemplatesList = ({ query, templates, onEdit, onRemove, onRedirect }) => {

    const { t } = useTranslation();
    const footerRef = useRef(null);
    const containerRef = useRef(null);
    const [titleHover, setTitleHover] = useState(false);
    const [descriptionHover, setDescriptionHover] = useState(false);

    const { menuRef, showMenu, menuCoordinates, onOpenMenu, toggleShowMenu } = useFixedCardMenu({ containerRef: containerRef, offsetY: 400, offsetX: 200 });

    return <div className={styles.wrapper}>
        <div className={styles.listContainer} ref={containerRef}>
            {templates.map(template => (
                <div key={template.id} className={styles.card} onClick={() => onEdit(template.id)}>
                    <div className={styles.header}>
                        <DotsBtn className={styles.dotsBtn} onClick={(event) => onOpenMenu({ event, id: template.id })} />
                    </div>
                    <div className={cx(styles.cardThumbnail, { [styles.fallback]: !template.thumbnail })}>
                        {template.thumbnail ? <img src={template.thumbnail} alt={template.name} className={styles.thumbnail} /> : <Icon src="thumbnailPlaceholder" className={cx(styles.thumbnail, styles.fallbackIcon)} />}
                        <div className={styles.aspectRatio}>{template.aspectRatio}</div>
                        <div className={styles.duration}>{formatSecondsToDuration(template.durationInFrames * 30 / 1000)}s</div>
                        {template.isDefault && <span className={styles.default}>{t('company.settings.fonts.default')}</span>}
                    </div>
                    <div className={styles.footer} ref={footerRef}>
                        <div className={styles.cardInfo}>
                            <Highlighter
                                highlightClassName="wordHighlighter"
                                className={styles.title}
                                searchWords={[query.search]}
                                autoEscape
                                textToHighlight={template.name}
                                onMouseOver={() => setTitleHover(template.id)}
                                onMouseOut={() => setTitleHover(null)}
                            />
                            <Tooltip wrapperRef={footerRef} isHover={titleHover == template.id} fullwidth={true} moveable={false}>
                                <Highlighter
                                    highlightClassName="wordHighlighter"
                                    className={styles.titleTooltip}
                                    searchWords={[query.search]}
                                    autoEscape
                                    textToHighlight={template.name}
                                />
                            </Tooltip>
                            {template?.description?.length > 0 && <>
                                <p className={styles.description} onMouseOver={() => setDescriptionHover(template.id)} onMouseOut={() => setDescriptionHover(null)}>{template.description}</p>
                                <Tooltip wrapperRef={footerRef} isHover={descriptionHover == template.id} fullwidth={true} moveable={false}>
                                    <span className={styles.titleTooltip}>
                                        {template.description}
                                    </span>
                                </Tooltip>
                            </>}
                        </div>
                        <div className={cx(styles.dateContainer)}>
                            <span className={styles.createdAt}>{t('general.date', { date: new Date(`${template.createdAt}`) })}</span>
                        </div>
                    </div>
                </div>
            ))}
        </div>
        {showMenu.flag && <Menu ref={menuRef} customStyles={{ position: 'absolute', left: `${menuCoordinates.left}px`, top: `${menuCoordinates.top}px`, transform: menuCoordinates.transform }} onClose={() => toggleShowMenu(null)} >
            <MenuItem className={styles.menuItem} onClick={() => {
                toggleShowMenu();
                onRedirect(showMenu.id);
            }}>
                <Icon src="pencilRuler" className={styles.actionIcon} />
                {t('company_settings.templates.open_in_editor')}
            </MenuItem>
            <MenuItem className={styles.menuItem} onClick={() => {
                toggleShowMenu();
                onEdit(showMenu.id);
            }}>
                <Icon src="pencil" className={styles.actionIcon} />
                {t('my_video.tools.edit')}
            </MenuItem>
            <MenuItem className={styles.menuItem} onClick={() => {
                toggleShowMenu();
                onRemove(showMenu.id);
            }}>
                <Icon src="bin_red" className={styles.actionIconBin} />
                {t('general.video_action_button.delete')}
            </MenuItem>
        </Menu>}
    </div>
}